import { render, staticRenderFns } from "./PartnerNotes.vue?vue&type=template&id=386cfd26"
import script from "./PartnerNotes.vue?vue&type=script&lang=js"
export * from "./PartnerNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports